import { NgModule } from '@angular/core';
import { EnvVariables } from './environment-variables.token';
import { environment } from './environment';
// import { environment } from './environment.qa';
// import { environment } from './environment.prod';

export function environmentFactory() {
    return environment;
}

@NgModule({
    providers: [
        {
            provide: EnvVariables,
            // 'useFactory' instead of 'useValue' so we can easily add more logic as needed
            useFactory: environmentFactory
        }
    ]
})

export class EnvironmentsModule { }
